
import api from "@/api";
import { Operator } from "@/api/dtos/Operator.schema";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import EditFrame from "../EditFrame.vue";
import { UsersModule } from "@/store/modules/UsersModule";
import { User } from "@/api/dtos/User.schema";
import { showToast } from "@/utils/toastService";
import { getAxiosResponse } from "@/utils/errorUtils";
import { OperatorsModule } from "@/store/modules/OperatorsModule";

@Component({
  components: {
    EditFrame,
  },
})
export default class OperatorPlatformService extends Vue {
  @Prop()
  operator!: Operator;

  platformServiceActive = false;
  private isInitialLoad = true;

  mounted(): void {
    this.platformServiceActive = this.operator.platformService;
    setTimeout(() => {
      this.isInitialLoad = false;
    }, 100);
  }

  get localUser(): User | null {
    return UsersModule.localUser;
  }

  async onPlatformServiceActiveChanged(): Promise<void> {
    try {
      await api.OperatorsApi.updatePlatformServiceActive(
        this.operator.uuid,
        this.platformServiceActive
      );
      
      await OperatorsModule.fetchOperator(this.operator.uuid);
      
      if (!this.isInitialLoad) {
        showToast({
          message: `Portalservice erfolgreich ${
            this.platformServiceActive ? "aktiviert" : "deaktiviert"
          }`,
          type: "success",
        });
      }
    } catch (e) {
      console.error("Operator platform service update error:", e);

      if (!this.isInitialLoad) {
        showToast({
          response: getAxiosResponse(e),
          message: `Portalservice konnte nicht ${
            this.platformServiceActive ? "aktiviert" : "deaktiviert"
          } werden`,
          type: "error",
        });
      }
    }
  }
}
